import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';
import { Button, Flex } from '@tq/ui-components';
import { useRecoilValue } from 'recoil';

import { ActionMenuButton } from 'components';
import { useNavigate, useNavigation, useResetSearchState } from 'hooks';
import { useAppBarMenuOptions } from '../../hooks';
import { isAdminOrConsulteeState } from 'store';

export type AppBarMenuProps = {
  location: string;
};

export const AppBarMenu: React.FC<AppBarMenuProps> = ({ location }) => {
  const { t } = useTranslation('app_bar');
  const { navigateToDashboard, navigateToReports } = useNavigate();
  const { isReportsPage, isConsultationPage } = useNavigation(location);
  const options = useAppBarMenuOptions();
  const resetSearch = useResetSearchState();

  const isAdminOrConsultee = useRecoilValue(isAdminOrConsulteeState);

  const getActiveColors = (isActive: boolean) => ({
    bgColor: isActive ? COLOURS.blue[700] : undefined,
    color: isActive ? 'white' : COLOURS.blue[600],
  });

  const goToDashboard = () => {
    resetSearch();
    navigateToDashboard();
  };

  return (
    <Flex gridGap={2} alignItems='center' data-testid='AppMenuBar'>
      {isAdminOrConsultee && (
        <>
          <Button
            variant={isConsultationPage ? 'primary' : 'tertiary'}
            {...getActiveColors(isConsultationPage)}
            size='sm'
            fontSize='md'
            onClick={goToDashboard}
          >
            {t('consultations_button', 'Consultations')}
          </Button>
          <Button
            variant={isReportsPage ? 'primary' : 'tertiary'}
            {...getActiveColors(isReportsPage)}
            size='sm'
            fontSize='md'
            onClick={navigateToReports}
          >
            {t('reports_button', 'Reports')}
          </Button>{' '}
        </>
      )}
      <ActionMenuButton
        label={t('manage_account', 'Manage account')}
        options={options}
        small
      />
    </Flex>
  );
};
